import _Tabs from "@material-ui/core/esm/Tabs";
import _Tab from "@material-ui/core/esm/Tab";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import classnames from 'classnames';
import { Link } from 'react-router';
import { styled } from '@material-ui/core/styles';
import { theme } from 'swag-client-common/styles/mui-themes';
import CSSClasses from './route-tabs.scss';
const LinkStyled = styled(Link)(({
  theme,
  color
}) => ({
  '&::after': {
    backgroundColor: color || theme.palette.primary.main
  },
  "&[aria-selected='true']": {
    color: color || theme.palette.primary.main
  }
}));
export const RouteTabs = /*#__PURE__*/React.forwardRef(function RouteTabs(props, ref) {
  const {
    tabs = [],
    classes,
    tabIndicatorProps = {},
    linkStyles = {},
    marginSize = 30,
    currentTab = {
      routes: null
    },
    className,
    isSublink,
    areTabsCentered = false,
    onMouseEnter,
    onMouseLeave,
    color
  } = props;
  const useMouseAction = tab => {
    return tab.subLinks && tab.subLinks.length > 0 && currentTab.route !== tab.route;
  };
  const onEnter = tab => e => {
    if (onMouseEnter && useMouseAction(tab)) {
      return onMouseEnter(e);
    }
    return;
  };
  const onLeave = tab => e => {
    if (onMouseLeave && useMouseAction(tab)) {
      return onMouseLeave(e);
    }
    return;
  };
  const getComponent = (tab, tabPosition) => {
    // eslint-disable-next-line react/display-name
    return /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(LinkStyled, _extends({}, props, {
      ref: ref,
      className: classnames({
        [CSSClasses.link]: !isSublink,
        [CSSClasses.sublink]: isSublink,
        [CSSClasses.isActive]: currentTab.route === tab.route
      }, className),
      onMouseLeave: onLeave(tab),
      onMouseEnter: onEnter(tab),
      to: tab.route,
      id: `tutorial${tab.text}`,
      color: color,
      style: _objectSpread({
        fontWeight: currentTab.route === tab.route ? 900 : 500,
        fontSize: '16px',
        display: 'flex',
        letterSpacing: '1px',
        minWidth: '30px',
        position: 'relative',
        padding: '30px 0',
        marginLeft: tabPosition === 0 ? '0' : `${marginSize}px`,
        marginRight: tabPosition === tabs.length - 1 ? '0' : `{${marginSize}px`
      }, linkStyles)
    })));
  };
  const tabIndicator = _objectSpread({}, tabIndicatorProps, {
    style: _objectSpread({}, tabIndicatorProps.style, {
      backgroundColor: color || theme.palette.primary.main
    })
  });
  return /*#__PURE__*/React.createElement(_Tabs, {
    value: currentTab.route || false,
    centered: areTabsCentered,
    variant: areTabsCentered ? 'fullWidth' : 'scrollable',
    scrollButtons: "off",
    classes: classes,
    TabIndicatorProps: tabIndicator,
    ref: ref
  }, tabs.filter(({
    isHide
  }) => !isHide).map((tab, position) => /*#__PURE__*/React.createElement(_Tab, {
    key: tab.route,
    "data-categoryId": tab.categoryId,
    component: getComponent(tab, position),
    label: tab.text,
    value: tab.route
  })));
});